module.exports = __webpack_public_path__ + "img/login-bg.98b740bf.png";